var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"width":_vm.width,"visible":_vm.visible,"title":_vm.title,"after-close":_vm.onClosed,"destroyOnClose":""},on:{"cancel":_vm.onHideModal,"ok":_vm.onHideModal}},[_vm._v(" 内容 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }